import { env } from "./env";
console.log(env);
const IP_ADDRESS = env.REACT_APP_CONST_API_URL || "http://localhost:8099";
const BASENAME = env.PUBLIC_URL;
const TICKET_IP_ADDRESS = env.REACT_APP_TICKET_URL || "http://localhost:5000";
const DEFAULT_COMPANY = env.REACT_APP_DEFAULT_COMPANY || "Alpaca Systems";
const STRIPE_PUBLIC_KEY = env.REACT_APP_STRIPE_PUBLIC_KEY;

export {
  IP_ADDRESS,
  BASENAME,
  TICKET_IP_ADDRESS,
  DEFAULT_COMPANY,
  STRIPE_PUBLIC_KEY,
};
